<div *ngIf="!isSnow" class="green-banner d-flex flex-column justify-content-center align-items-center text-center mb-6">
  <h1 class="display-3 text-white m-0 p-0">{{ title }}</h1>
</div>

<div *ngIf="viewAVCDashboards; else noPermissions">
  <div class="dashboard-avc container px-lg-10 px-md-10">
    <ng-container *ngIf="hasOffices; else noData">
      <div class="px-lg-8 px-md-8">
        <div class="filters">
          <app-kpi-filter
            [class.d-none]="(isRequestLoading$ | async) || (isOfficesLoading$ | async)"
            class="d-block h-100"
            (filterChanged)="onFilterChange($event)"
          ></app-kpi-filter>
        </div>

        <ng-container
          *ngIf="(isRequestLoading$ | async) === false && (isOfficesLoading$ | async) === false; else loadingContainer"
        >
          <ng-container *ngIf="hasStatisticsData; else noData">
            <div class="kpi-type-selector">
              <div role="radiogroup" aria-labelledby="display-radio-group" class="d-flex">
                <span id="display-radio-group" i18n="@@amadeus-direct.avc-dashboard.display">Show</span>
                <div class="form-check ms-6" *ngFor="let type of statisticsTypes">
                  <input
                    [id]="type"
                    class="form-check-input"
                    type="radio"
                    [value]="type"
                    (change)="loadData()"
                    [(ngModel)]="statisticsType"
                  />
                  <label class="form-check-label" [for]="type"> {{ labels[type] }} </label>
                </div>
              </div>
            </div>
            <div class="row d-flex">
              <div class="col-8">
                <div class="bookings-and-revenues-wrapper col-12">
                  <ng-container *ngIf="statistics; else showKaliuk">
                    <app-bookings-and-revenues [statistics]="statistics"></app-bookings-and-revenues>
                  </ng-container>
                  <ng-template #showKaliuk>
                    <figure class="d-flex justify-content-center align-items-center h-100">
                      <svg class="kaliuk kaliuk-big">
                        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
                      </svg>
                    </figure>
                  </ng-template>
                  <div class="export-buttons"></div>
                </div>
                <div class="kpi-summary row d-block mt-5">
                  <div class="dashboard-print-container d-flex justify-content-end align-items-center">
                    <div class="print-btn" (click)="print()">
                      <span class="title me-4" i18n="@@dashboard-footer.buttonPrint">Print</span>
                      <svg class="print-button-svg">
                        <use href="/assets/images/svg_ico/icons.svg#ic_print"></use>
                      </svg>
                    </div>
                  </div>
                  <div>
                    <app-kpi-summary [kpiSummaryData]="kpiSummaryData"></app-kpi-summary>
                  </div>
                </div>
                <br/>
                <br/>
                <div>
                  <p>
                    <i i18n="@@amadeus-direct.avc-dashboard.legalDisclaimer-line1">This module displays revenue data based on individual room bookings. All metrics included are for information purposes only.</i>
                    <br/>
                    <i i18n="@@amadeus-direct.avc-dashboard.legalDisclaimer-line2">Invoicing details may differ, so do not use any data on this module for reconciliation.</i>
                  </p>
                </div>
              </div>
              <div class="top-destinations-wrapper col-4">
                <ul
                  ngbNav
                  #nav="ngbNav"
                  [(activeId)]="topDestinationsTab"
                  [destroyOnHide]="false"
                  class="nav-tabs fix-border-bottom"
                  data-test="top-destinations-nav"
                >
                  <li [ngbNavItem]="1">
                    <a
                      ngbNavLink
                      i18n="@@amadeus-direct.avc-dashboard.tab.towns"
                      data-test="top-destinations-tab-towns"
                    >
                      Cities
                    </a>
                    <ng-template ngbNavContent>
                      <app-top-destinations
                        *ngIf="topDestinationsFilter && topDestinationsTab === 1"
                        [statisticsType]="statisticsType"
                        [destinationType]="DestinationType.CITY"
                        [filter]="topDestinationsFilter"
                      ></app-top-destinations>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2" [disabled]="areCountriesDisabled()">
                    <a
                      ngbNavLink
                      i18n="@@amadeus-direct.avc-dashboard.tab.countries"
                      data-test="top-destinations-tab-countries"
                    >
                      Countries
                    </a>
                    <ng-template ngbNavContent>
                      <app-top-destinations
                        *ngIf="topDestinationsFilter && topDestinationsTab === 2"
                        [statisticsType]="statisticsType"
                        [destinationType]="DestinationType.COUNTRY"
                        [filter]="topDestinationsFilter"
                      ></app-top-destinations>
                    </ng-template>
                  </li>
                </ul>
                <div [ngbNavOutlet]="nav" class="mt-2 no-padding-tabs"></div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noData>
      <div
        [class.d-none]="(isRequestLoading$ | async) || (isOfficesLoading$ | async)"
        class="d-flex justify-content-center"
        *ngIf="!hasOffices || !hasStatisticsData"
      >
        <figure class="figure" data-test="kaliuk">
          <svg class="kaliuk kaliuk-big">
            <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
          </svg>
          <figcaption class="figure-caption">
            <h4 i18n="@@amadeus-direct.avc-dashboard.no-data">
              No data retrieved. Change your filter selection to access data.
            </h4>
          </figcaption>
        </figure>
      </div>
    </ng-template>

    <ng-template #loadingContainer>
      <div class="d-block py-2 mt-4 loading-container text-center" data-test="loading-indicator">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #noPermissions>
  <div class="d-flex justify-content-center">
    <figure class="figure" data-test="kaliuk">
      <svg class="kaliuk kaliuk-big">
        <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
      </svg>
      <figcaption class="figure-caption">
        <h4 i18n="@@amadeus-direct.avc-dashboard.dashboards.no-permissions">
          No data retrieved. Please request permission to access data.
        </h4>
      </figcaption>
    </figure>
  </div>
</ng-template>
